<template>
  <div>
    <b-card class="p-0 filter-card rounded-lg">
      <div
        v-if="load"
        class="text-center py-5"
      >
        <b-spinner
          variant="primary"
          label="جاري التحميل..."
        />
      </div>
      <b-row v-else>
        <b-col cols="12">
          <!-- Header Section -->
          <div class="customer-header mb-4 p-4 bg-light rounded">
            <b-row class="align-items-center">
              <b-col
                cols="auto"
                class="text-center mb-2"
              >
                <b-avatar
                  size="70"
                  class="customer-avatar"
                  :alt="customer.name"
                >
                  {{ getInitials(customer.name) }}
                </b-avatar>
              </b-col>
              <b-col>
                <h3 class="mb-2 text-primary">
                  {{ customer.name || 'غير محدد' }}
                </h3>
                <p class="text-muted mb-2">
                  <feather-icon
                    icon="HashIcon"
                    size="16"
                    class="ml-1"
                  />
                  {{ customer.customer_number || '-' }}
                </p>
                <p class="mb-2">
                  <small class="text-muted d-block">حساب الدفتر</small>
                  <strong>{{ customerGlText }}</strong>
                </p>
                <div class="d-flex flex-wrap gap-2">
                  <b-badge
                    :variant="getStatusVariant(customer.status)"
                    class="fs-6"
                  >
                    {{ getStatusText(customer.status) }}
                  </b-badge>
                  <b-badge
                    variant="secondary"
                    class="fs-6 "
                    style="margin-right:5px"
                  >
                    <feather-icon
                      icon="UserIcon"
                      size="14"
                      class="ml-1"
                    />
                    {{ getCustomerTypeText(customer.type) }}
                  </b-badge>
                </div>
              </b-col>
              <!-- <b-col cols="auto">
                                <b-button variant="outline-primary" class="btn-icon">
                                    <feather-icon icon="EditIcon" size="16" />
                                </b-button>
                            </b-col> -->
            </b-row>
          </div>

          <!-- المعلومات الأساسية -->
          <b-row>
            <b-col lg="8">
              <b-card
                class="h-100"
                header="المعلومات الأساسية"
              >
                <b-row>
                  <b-col
                    md="6"
                    class="mb-3"
                  >
                    <div class="info-item">
                      <feather-icon
                        icon="CreditCardIcon"
                        size="18"
                        class="text-primary ml-2"
                      />
                      <div>
                        <small class="text-muted d-block">الرقم القومي</small>
                        <strong>{{ customer.national_id || 'غير محدد' }}</strong>
                      </div>
                    </div>
                  </b-col>
                  <b-col
                    md="6"
                    class="mb-3"
                  >
                    <div class="info-item">
                      <feather-icon
                        icon="MailIcon"
                        size="18"
                        class="text-primary ml-2"
                      />
                      <div>
                        <small class="text-muted d-block">البريد الإلكتروني</small>
                        <strong>{{ customer.email || 'غير محدد' }}</strong>
                      </div>
                    </div>
                  </b-col>
                  <b-col
                    md="6"
                    class="mb-3"
                  >
                    <div class="info-item">
                      <feather-icon
                        icon="PhoneIcon"
                        size="18"
                        class="text-primary ml-2"
                      />
                      <div>
                        <small class="text-muted d-block">رقم الهاتف</small>
                        <strong v-if="customer.phone">{{ customer.phone }}</strong>
                        <span
                          v-else
                          class="text-muted"
                        >غير محدد</span>
                        <div v-if="customer.mobile">
                          <small class="text-muted">موبايل إضافي:</small> {{ customer.mobile }}
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col
                    md="6"
                    class="mb-3"
                  >
                    <div class="info-item">
                      <feather-icon
                        icon="BriefcaseIcon"
                        size="18"
                        class="text-primary ml-2"
                      />
                      <div>
                        <small class="text-muted d-block">جهة العمل</small>
                        <strong>
                          {{ customer.authority_name || (customer.authority && customer.authority.authority_name) || 'غير محدد' }}
                          <span v-if="customer.authority_type_label || (customer.authority && customer.authority.authority_type_label)">
                            ({{ customer.authority_type_label || (customer.authority && customer.authority.authority_type_label) }})
                          </span>
                        </strong>
                      </div>
                    </div>
                  </b-col>
                  <b-col
                    cols="12"
                    class="mb-3"
                  >
                    <div class="info-item">
                      <feather-icon
                        icon="MapPinIcon"
                        size="18"
                        class="text-primary ml-2"
                      />
                      <div>
                        <small class="text-muted d-block">العنوان</small>
                        <strong>{{ customer.address || 'غير محدد' }}</strong>
                      </div>
                    </div>
                  </b-col>
                  <b-col
                    md="6"
                    class="mb-3"
                  >
                    <div class="info-item">
                      <feather-icon
                        icon="UserCheckIcon"
                        size="18"
                        class="text-primary ml-2"
                      />
                      <div>
                        <small class="text-muted d-block">الوظيفة</small>
                        <strong>{{ customer.position || 'غير محدد' }}</strong>
                      </div>
                    </div>
                  </b-col>
                  <b-col
                    cols="12"
                    class="mb-3"
                  >
                    <div class="info-item align-items-center">
                      <feather-icon
                        icon="CreditCardIcon"
                        size="18"
                        class="text-primary ml-2"
                      />
                      <div>
                        <small class="text-muted d-block">صورة بطاقة الرقم القومي</small>

                        <template v-if="customer.media">
                          <a
                            v-for="item in customer.media"
                            :key="item.id"
                            :href="item.url"
                            style="cursor: pointer;"
                            target="_blank"
                            rel="noopener"
                          >
                            <img
                              :src="item.url"
                              alt="صورة البطاقة"
                              style="max-width:80px;max-height:80px; border-radius:4px; border:1px solid #eee;box-shadow:0 1px 6px #eee;margin:4px 0;"
                            >
                          </a>
                        </template>

                        <template v-else>
                          <span class="text-muted">غير متوفر</span>
                        </template>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>

            <b-col lg="4">
              <!-- المعلومات المالية -->
              <b-card
                header="المعلومات المالية"
                class="mb-3"
              >
                <div class="financial-info">
                  <div class="financial-item text-center mb-3 p-3 bg-light rounded">
                    <feather-icon
                      icon="DollarSignIcon"
                      size="24"
                      class="text-success mb-2"
                    />
                    <small class="text-muted d-block">الحد الائتماني</small>
                    <h4 class="text-success mb-0">
                      {{ formatCurrency(customer.credit_limit) }}
                    </h4>
                  </div>
                  <div class="financial-item text-center p-3 bg-light rounded">
                    <feather-icon
                      icon="PieChartIcon"
                      size="24"
                      class="text-info mb-2"
                    />
                    <small class="text-muted d-block">الرصيد الحالي</small>
                    <h4
                      :class="getBalanceClass(customer.current_balance)"
                      class="mb-0"
                    >
                      {{ formatCurrency(customer.current_balance) }}
                    </h4>
                  </div>
                </div>
              </b-card>

              <!-- معلومات إضافية -->
              <b-card header="معلومات إضافية">
                <div class="additional-info">
                  <div class="info-row d-flex justify-content-between py-2 border-bottom">
                    <span class="text-muted">نوع العميل:</span>
                    <strong>{{ getCustomerTypeText(customer.type) }}</strong>
                  </div>
                  <div
                    v-if="customer.company_name"
                    class="info-row d-flex justify-content-between py-2 border-bottom"
                  >
                    <span class="text-muted">اسم الشركة:</span>
                    <strong>{{ customer.company_name }}</strong>
                  </div>
                  <div
                    v-if="customer.commercial_register"
                    class="info-row d-flex justify-content-between py-2 border-bottom"
                  >
                    <span class="text-muted">السجل التجاري:</span>
                    <strong>{{ customer.commercial_register }}</strong>
                  </div>
                  <div
                    v-if="customer.tax_number"
                    class="info-row d-flex justify-content-between py-2 border-bottom"
                  >
                    <span class="text-muted">الرقم الضريبي:</span>
                    <strong>{{ customer.tax_number }}</strong>
                  </div>
                  <div class="info-row d-flex justify-content-between py-2">
                    <span class="text-muted">تاريخ الإنشاء:</span>
                    <strong>{{ formatDate(customer.created_at) }}</strong>
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row>

          <!-- الملاحظات -->
          <b-card
            v-if="customer.notes"
            header="الملاحظات"
            class="mt-3"
          >
            <p class="mb-0">
              {{ customer.notes }}
            </p>
          </b-card>

          <!-- جهات الاتصال -->
          <b-card
            v-if="customer.contact_persons"
            header="جهات الاتصال"
            class="mt-3"
          >
            <b-row>
              <b-col
                v-for="(contact, index) in parsedContactPersons"
                :key="index"
                md="6"
                class="mb-3"
              >
                <b-card class="h-100">
                  <h6 class="text-primary">
                    {{ contact.name }}
                  </h6>
                  <p
                    v-if="contact.position"
                    class="mb-1"
                  >
                    <small class="text-muted">المنصب:</small> {{ contact.position }}
                  </p>
                  <p
                    v-if="contact.email"
                    class="mb-1"
                  >
                    <small class="text-muted">البريد:</small> {{ contact.email }}
                  </p>
                  <p
                    v-if="contact.phone"
                    class="mb-0"
                  >
                    <small class="text-muted">الهاتف:</small> {{ contact.phone }}
                  </p>
                </b-card>
              </b-col>
            </b-row>
          </b-card>

          <!-- المعاملات المالية -->
          <b-card
            header="المعاملات المالية"
            class="mt-3"
          >
            <b-button
              v-if="hasPermission('view invoices')"
              variant="outline-primary"
              size="sm"
              class="mb-1"
              :to="{ name: 'ledger-customer-statement', params: { id: $route.params.id } }"
            >
              كشف حساب عميل
            </b-button>
            <b-tabs content-class="mt-3">
              <!-- Direct Customer Transactions Tab -->
              <b-tab
                title="معاملات العميل المباشرة"
                active
              >
                <b-card
                  no-body
                  class="shadow-sm rounded-lg"
                >
                  <b-card-header class="bg-primary text-white">
                    <h5 class="card-header mb-0">
                      معاملات العميل المباشرة
                    </h5>
                  </b-card-header>
                  <b-card-body>
                    <!-- Filters -->
                    <b-card class="mb-3">
                      <b-row>
                        <b-col md="3">
                          <b-form-group
                            label="نوع المعاملة"
                            label-for="direct_transaction_type"
                          >
                            <v-select
                              id="direct_transaction_type"
                              v-model="directFilters.transaction_type"
                              :options="transactionTypeOptions"
                              :reduce="val => val.value"
                              :get-option-label="option => $i18n.locale === 'ar' ? option.label_ar : option.label"
                              :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                              clearable
                              @input="applyDirectFilters"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="3">
                          <b-form-group
                            label="الحالة"
                            label-for="direct_status"
                          >
                            <v-select
                              id="direct_status"
                              v-model="directFilters.status"
                              :options="statusOptions"
                              :reduce="val => val.value"
                              :get-option-label="option => $i18n.locale === 'ar' ? option.label_ar : option.label"
                              :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                              clearable
                              @input="applyDirectFilters"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="3">
                          <b-form-group
                            label="من تاريخ"
                            label-for="direct_date_from"
                          >
                            <b-form-input
                              id="direct_date_from"
                              v-model="directFilters.date_from"
                              type="date"
                              @change="applyDirectFilters"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="3">
                          <b-form-group
                            label="إلى تاريخ"
                            label-for="direct_date_to"
                          >
                            <b-form-input
                              id="direct_date_to"
                              v-model="directFilters.date_to"
                              type="date"
                              @change="applyDirectFilters"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col
                          md="12"
                          class="d-flex align-items-end"
                        >
                          <b-button
                            variant="outline-secondary"
                            class="mr-2"
                            @click="resetDirectFilters"
                          >
                            <feather-icon
                              icon="XIcon"
                              class="mr-1"
                            />
                            إعادة تعيين
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-card>

                    <!-- Loading State -->
                    <div
                      v-if="loading.direct"
                      class="text-center py-5"
                    >
                      <b-spinner
                        variant="primary"
                        label="جاري التحميل..."
                      />
                    </div>

                    <!-- Transactions Table -->
                    <b-table
                      v-else
                      :items="directTransactions"
                      :fields="transactionFields"
                      striped
                      responsive
                      :empty-text="'لا توجد معاملات'"
                    >
                      <template #cell(transaction_number)="data">
                        <b-link
                          :to="{ name: 'accounting-transactions-view', params: { id: data.item.id } }"
                          class="font-weight-bold"
                        >
                          {{ data.item.transaction_number }}
                        </b-link>
                      </template>
                      <template #cell(amount)="data">
                        <span
                          :class="(data.item.transaction_type && data.item.transaction_type.value === 'income') ? 'text-success' : 'text-danger'"
                          class="font-weight-bold"
                        >
                          {{ formatCurrency(data.item.amount) }}
                        </span>
                      </template>
                      <template #cell(status)="data">
                        <b-badge :variant="getTransactionStatusVariant(data.item.status)">
                          {{ getStatusLabel(data.item.status) }}
                        </b-badge>
                      </template>
                      <template #cell(transaction_date)="data">
                        {{ formatDate(data.item.transaction_date) }}
                      </template>
                      <template #cell(transaction_type)="data">
                        {{ getTransactionTypeLabel(data.item.transaction_type) }}
                      </template>
                      <template #cell(transaction_reason)="data">
                        {{ getTransactionReasonLabel(data.item.transaction_reason) }}
                      </template>
                      <template #cell(source)="data">
                        <b-link
                          v-if="getSourceRoute(data.item.source, data.item.payment_source)"
                          :to="getSourceRoute(data.item.source, data.item.payment_source)"
                        >
                          {{ getSourceLabel(data.item.source, data.item.payment_source) }}
                        </b-link>
                        <span v-else>
                          {{ getSourceLabel(data.item.source, data.item.payment_source) }}
                        </span>
                      </template>
                      <template #cell(project)="data">
                        {{ data.item.project ? data.item.project.name : '-' }}
                      </template>
                      <template #cell(actions)="data">
                        <div
                          v-if="data.item"
                          class="d-flex align-items-center"
                        >
                          <b-link
                            v-if="hasReceipt(data.item)"
                            v-b-tooltip.hover.top="'عرض الإيصال'"
                            class="ml-1 text-info"
                            @click="showReceiptModal(data.item)"
                          >
                            <feather-icon
                              icon="EyeIcon"
                              size="18"
                            />
                          </b-link>
                        </div>
                      </template>
                    </b-table>

                    <!-- Pagination -->
                    <b-pagination
                      v-if="directPagination.total > 0"
                      v-model="directFilters.page"
                      :total-rows="directPagination.total"
                      :per-page="directFilters.per_page"
                      class="mt-3"
                      @change="onDirectPageChange"
                    />
                  </b-card-body>
                </b-card>
              </b-tab>

              <!-- Customer Project Transactions Tab -->
              <b-tab title="معاملات مشاريع العميل">
                <b-card
                  no-body
                  class="shadow-sm rounded-lg"
                >
                  <b-card-header class="bg-info text-white">
                    <h5 class="card-header mb-0">
                      معاملات مشاريع العميل
                    </h5>
                  </b-card-header>
                  <b-card-body>
                    <!-- Filters -->
                    <b-card class="mb-3">
                      <b-row>
                        <b-col md="3">
                          <b-form-group
                            label="نوع المعاملة"
                            label-for="project_transaction_type"
                          >
                            <v-select
                              id="project_transaction_type"
                              v-model="projectFilters.transaction_type"
                              :options="transactionTypeOptions"
                              :reduce="val => val.value"
                              :get-option-label="option => $i18n.locale === 'ar' ? option.label_ar : option.label"
                              :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                              clearable
                              @input="applyProjectFilters"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="3">
                          <b-form-group
                            label="الحالة"
                            label-for="project_status"
                          >
                            <v-select
                              id="project_status"
                              v-model="projectFilters.status"
                              :options="statusOptions"
                              :reduce="val => val.value"
                              :get-option-label="option => $i18n.locale === 'ar' ? option.label_ar : option.label"
                              :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                              clearable
                              @input="applyProjectFilters"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="3">
                          <b-form-group
                            label="من تاريخ"
                            label-for="project_date_from"
                          >
                            <b-form-input
                              id="project_date_from"
                              v-model="projectFilters.date_from"
                              type="date"
                              @change="applyProjectFilters"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="3">
                          <b-form-group
                            label="إلى تاريخ"
                            label-for="project_date_to"
                          >
                            <b-form-input
                              id="project_date_to"
                              v-model="projectFilters.date_to"
                              type="date"
                              @change="applyProjectFilters"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col
                          md="12"
                          class="d-flex align-items-end"
                        >
                          <b-button
                            variant="outline-secondary"
                            class="mr-2"
                            @click="resetProjectFilters"
                          >
                            <feather-icon
                              icon="XIcon"
                              class="mr-1"
                            />
                            إعادة تعيين
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-card>

                    <!-- Loading State -->
                    <div
                      v-if="loading.project"
                      class="text-center py-5"
                    >
                      <b-spinner
                        variant="primary"
                        label="جاري التحميل..."
                      />
                    </div>

                    <!-- Transactions Table -->
                    <b-table
                      v-else
                      :items="projectTransactions"
                      :fields="transactionFields"
                      striped
                      responsive
                      :empty-text="'لا توجد معاملات'"
                    >
                      <template #cell(transaction_number)="data">
                        <b-link
                          :to="{ name: 'accounting-transactions-view', params: { id: data.item.id } }"
                          class="font-weight-bold"
                        >
                          {{ data.item.transaction_number }}
                        </b-link>
                      </template>
                      <template #cell(amount)="data">
                        <span
                          :class="(data.item.transaction_type && data.item.transaction_type.value === 'income') ? 'text-success' : 'text-danger'"
                          class="font-weight-bold"
                        >
                          {{ formatCurrency(data.item.amount) }}
                        </span>
                      </template>
                      <template #cell(status)="data">
                        <b-badge :variant="getTransactionStatusVariant(data.item.status)">
                          {{ getStatusLabel(data.item.status) }}
                        </b-badge>
                      </template>
                      <template #cell(transaction_date)="data">
                        {{ formatDate(data.item.transaction_date) }}
                      </template>
                      <template #cell(transaction_type)="data">
                        {{ getTransactionTypeLabel(data.item.transaction_type) }}
                      </template>
                      <template #cell(transaction_reason)="data">
                        {{ getTransactionReasonLabel(data.item.transaction_reason) }}
                      </template>
                      <template #cell(source)="data">
                        <b-link
                          v-if="getSourceRoute(data.item.source, data.item.payment_source)"
                          :to="getSourceRoute(data.item.source, data.item.payment_source)"
                        >
                          {{ getSourceLabel(data.item.source, data.item.payment_source) }}
                        </b-link>
                        <span v-else>
                          {{ getSourceLabel(data.item.source, data.item.payment_source) }}
                        </span>
                      </template>
                      <template #cell(project)="data">
                        <b-link
                          v-if="data.item.project"
                          :to="{ name: 'projectDetails', params: { id: data.item.project.id } }"
                        >
                          {{ data.item.project.name }}
                        </b-link>
                        <span v-else>-</span>
                      </template>
                      <template #cell(actions)="data">
                        <div
                          v-if="data.item"
                          class="d-flex align-items-center"
                        >
                          <b-link
                            v-if="hasReceipt(data.item)"
                            v-b-tooltip.hover.top="'عرض الإيصال'"
                            class="ml-1 text-info"
                            @click="showReceiptModal(data.item)"
                          >
                            <feather-icon
                              icon="EyeIcon"
                              size="18"
                            />
                          </b-link>
                        </div>
                      </template>
                    </b-table>

                    <!-- Pagination -->
                    <b-pagination
                      v-if="projectPagination.total > 0"
                      v-model="projectFilters.page"
                      :total-rows="projectPagination.total"
                      :per-page="projectFilters.per_page"
                      class="mt-3"
                      @change="onProjectPageChange"
                    />
                  </b-card-body>
                </b-card>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>

      <!-- Activity Logs Section -->
      <b-row v-if="hasPermission('view activity_logs')">
        <b-col cols="12">
          <b-card header="سجل النشاطات">
            <ActivityLogs
              :model-type="'customer'"
              :model-id="Number(customerId)"
              :show-filters="true"
              :per-page="15"
            />
          </b-card>
        </b-col>
      </b-row>
    </b-card>

    <!-- View Receipt Modal -->
    <b-modal
      id="view-receipt-modal"
      ref="viewReceiptModal"
      title="عرض الإيصال"
      size="xl"
      centered
      @hidden="currentReceiptUrl = null"
    >
      <div
        v-if="currentReceiptUrl"
        class="receipt-viewer"
      >
        <!-- Image Viewer -->
        <div
          v-if="isImageFile(currentReceiptUrl)"
          class="text-center"
        >
          <img
            :src="currentReceiptUrl"
            alt="Receipt"
            class="img-fluid"
            style="max-height: 70vh; width: auto;"
          >
        </div>
        <!-- PDF Viewer -->
        <div
          v-else-if="isPdfFile(currentReceiptUrl)"
          class="pdf-viewer"
        >
          <iframe
            :src="currentReceiptUrl"
            frameborder="0"
            style="width: 100%; height: 70vh;"
          />
        </div>
        <!-- Fallback for other file types -->
        <div
          v-else
          class="text-center py-5"
        >
          <p class="text-muted">
            لا يمكن عرض هذا النوع من الملفات
          </p>
          <b-button
            :href="currentReceiptUrl"
            target="_blank"
            variant="primary"
          >
            <feather-icon
              icon="DownloadIcon"
              class="mr-1"
            />
            تحميل الملف
          </b-button>
        </div>
      </div>
      <div
        v-else
        class="text-center py-5"
      >
        <b-spinner variant="primary" />
      </div>
      <template #modal-footer="{ ok }">
        <b-button
          variant="secondary"
          @click="ok()"
        >
          إغلاق
        </b-button>
        <b-button
          v-if="currentReceiptUrl"
          :href="currentReceiptUrl"
          target="_blank"
          variant="primary"
        >
          <feather-icon
            icon="DownloadIcon"
            class="mr-1"
          />
          تحميل
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BTable, BButton, BFormCheckbox, BCard, BRow, BCol, BBadge, BCardText,
  BAvatar, BLink, VBTooltip, BSpinner, BPagination, BFormInput, BInputGroup,
  BForm, BFormGroup, BFormDatepicker, BFormRadio, BFormTextarea, BTabs, BTab, BModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import flatPickr from 'vue-flatpickr-component'
import * as customerTransactionsAPI from '@/api/customers/customerTransactions'
import ActivityLogs from '@/components/ActivityLogs.vue'
import { glAccountText } from '@/utils/ledger'

export default {
  components: {
    BTable,
    flatPickr,
    BFormTextarea,
    BFormRadio,
    BFormDatepicker,
    BButton,
    BFormCheckbox,
    BCard,
    BForm,
    BRow,
    BCol,
    BBadge,
    BFormGroup,
    BAvatar,
    BInputGroup,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
    BCardText,
    vSelect,
    BLink,
    BSpinner,
    BPagination,
    BFormInput,
    FeatherIcon,
    BTabs,
    BTab,
    BModal,
    ActivityLogs,
  },
  computed: {
    ...mapGetters({
      customer: 'customers/customer',
      load: 'customers/load',
      isLoggedIn: 'auth/isLoggedIn',
    }),
    customerId() {
      return this.$route.params.id ? this.$route.params.id : null
    },
    customerGlText() {
      return glAccountText(this.customer) || '—'
    },
    parsedContactPersons() {
      if (!this.customer.contact_persons) return []
      try {
        return typeof this.customer.contact_persons === 'string'
          ? JSON.parse(this.customer.contact_persons)
          : this.customer.contact_persons
      } catch (e) {
        return []
      }
    },
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },

  data() {
    return {
      nationalIdMediaBlobUrl: null,
      nationalIdMediaError: null,
      // Direct transactions
      directTransactions: [],
      directFilters: {
        transaction_type: null,
        status: null,
        date_from: null,
        date_to: null,
        page: 1,
        per_page: 15,
        sort_by: 'created_at',
        sort_order: 'desc',
      },
      directPagination: {
        current_page: 1,
        per_page: 15,
        total: 0,
        last_page: 1,
        from: null,
        to: null,
      },
      // Project transactions
      projectTransactions: [],
      projectFilters: {
        transaction_type: null,
        status: null,
        date_from: null,
        date_to: null,
        page: 1,
        per_page: 15,
        sort_by: 'created_at',
        sort_order: 'desc',
      },
      projectPagination: {
        current_page: 1,
        per_page: 15,
        total: 0,
        last_page: 1,
        from: null,
        to: null,
      },
      loading: {
        direct: false,
        project: false,
      },
      transactionFields: [
        { key: 'transaction_number', label: 'رقم المعاملة' },
        { key: 'transaction_date', label: 'التاريخ' },
        { key: 'transaction_type', label: 'نوع المعاملة' },
        { key: 'transaction_reason', label: 'سبب المعاملة' },
        { key: 'source', label: 'المصدر' },
        { key: 'project', label: 'المشروع' },
        { key: 'amount', label: 'المبلغ' },
        { key: 'status', label: 'الحالة' },
        { key: 'actions', label: 'الإجراءات' },
      ],
      statusOptions: [
        { value: 'pending', label: 'Pending', label_ar: 'قيد الانتظار' },
        { value: 'approved', label: 'Approved', label_ar: 'موافق عليه' },
        { value: 'rejected', label: 'Rejected', label_ar: 'مرفوض' },
        { value: 'cancelled', label: 'Cancelled', label_ar: 'ملغي' },
      ],
      transactionTypeOptions: [
        { value: 'income', label: 'Income', label_ar: 'دخل' },
        { value: 'expense', label: 'Expense', label_ar: 'مصروف' },
      ],
      currentReceiptUrl: null,
    }
  },
  watch: {
    customerId: {
      handler(newVal) {
        if (newVal) {
          this.loadDirectTransactions()
          this.loadProjectTransactions()
        }
      },
    },
  },
  mounted() {
    this.init()
    // if you want to handle updates on id change, add a watcher on customerId
  },
  methods: {
    getInitials(name) {
      if (!name) return 'ع'
      return name.split(' ').map(n => n.charAt(0)).join('').toUpperCase()
    },

    getStatusVariant(status) {
      const variants = {
        active: 'success',
        inactive: 'secondary',
        suspended: 'warning',
        blocked: 'danger',
      }
      return variants[status] || 'secondary'
    },
    getTransactionStatusVariant(status) {
      const statusValue = typeof status === 'object' && status !== null ? status.value : status
      const variants = {
        pending: 'warning',
        approved: 'success',
        rejected: 'danger',
        cancelled: 'secondary',
      }
      return variants[statusValue] || 'secondary'
    },

    getStatusText(status) {
      const statusMap = {
        active: 'نشط',
        inactive: 'غير نشط',
        suspended: 'موقوف',
        blocked: 'محظور',
      }
      return statusMap[status] || status
    },

    getCustomerTypeText(type) {
      const typeMap = {
        individual: 'فرد',
        company: 'شركة',
      }
      return typeMap[type] || type
    },

    formatCurrency(amount) {
      if (!amount || amount === '0.00') return '٠.٠٠ ₪'
      return new Intl.NumberFormat('ar-EG', {
        style: 'currency',
        currency: 'EGP',
      }).format(amount)
    },

    formatDate(dateString) {
      if (!dateString) return 'غير محدد'
      const date = new Date(dateString)
      return date.toLocaleDateString('ar-EG', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    },

    getBalanceClass(balance) {
      const numBalance = parseFloat(balance)
      return numBalance >= 0 ? 'text-success' : 'text-danger'
    },

    async onNationalIdImageError(event) {
      // Try to fetch image manually to inspect error type
      try {
        const response = await fetch(this.customer.national_id_image_url, { credentials: 'include' })
        if (response.status === 401) {
          this.nationalIdImageError = '401'
        } else {
          const text = await response.text()
          if (text.includes('Route [login] not defined')) {
            this.nationalIdImageError = 'route_login'
          } else {
            this.nationalIdImageError = 'other'
          }
        }
      } catch (err) {
        this.nationalIdImageError = 'other'
      }
    },
    async loadNationalIdImageBlob(url) {
      return this.getPreviewBlobUrl(url, null, msg => { this.nationalIdMediaError = msg })
    },
    init() {
      this.$store.dispatch('customers/show', { id: this.customerId }).then(() => {
        this.loadNationalIdImageBlob() // call blob loading after fetch
        this.loadDirectTransactions()
        this.loadProjectTransactions()
      })
    },
    async loadDirectTransactions() {
      if (!this.customerId) return
      this.loading.direct = true
      try {
        const params = { ...this.directFilters }
        // Remove null/undefined values
        Object.keys(params).forEach(key => {
          if (params[key] === null || params[key] === undefined || params[key] === '') {
            delete params[key]
          }
        })
        const response = await customerTransactionsAPI.getCustomerTransactions(this.customerId, params)
        if (response.success && response.data) {
          this.directTransactions = response.data
          this.directPagination = response.meta || {}
        }
      } catch (error) {
        console.error('Error loading direct transactions:', error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطأ',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: 'حدث خطأ أثناء تحميل معاملات العميل',
          },
        })
      } finally {
        this.loading.direct = false
      }
    },
    async loadProjectTransactions() {
      if (!this.customerId) return
      this.loading.project = true
      try {
        const params = { ...this.projectFilters }
        // Remove null/undefined values
        Object.keys(params).forEach(key => {
          if (params[key] === null || params[key] === undefined || params[key] === '') {
            delete params[key]
          }
        })
        const response = await customerTransactionsAPI.getCustomerProjectTransactions(this.customerId, params)
        if (response.success && response.data) {
          this.projectTransactions = response.data
          this.projectPagination = response.meta || {}
        }
      } catch (error) {
        console.error('Error loading project transactions:', error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطأ',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: 'حدث خطأ أثناء تحميل معاملات المشاريع',
          },
        })
      } finally {
        this.loading.project = false
      }
    },
    applyDirectFilters() {
      this.directFilters.page = 1
      this.loadDirectTransactions()
    },
    applyProjectFilters() {
      this.projectFilters.page = 1
      this.loadProjectTransactions()
    },
    resetDirectFilters() {
      this.directFilters = {
        transaction_type: null,
        status: null,
        date_from: null,
        date_to: null,
        page: 1,
        per_page: 15,
        sort_by: 'created_at',
        sort_order: 'desc',
      }
      this.loadDirectTransactions()
    },
    resetProjectFilters() {
      this.projectFilters = {
        transaction_type: null,
        status: null,
        date_from: null,
        date_to: null,
        page: 1,
        per_page: 15,
        sort_by: 'created_at',
        sort_order: 'desc',
      }
      this.loadProjectTransactions()
    },
    onDirectPageChange(page) {
      this.directFilters.page = page
      this.loadDirectTransactions()
    },
    onProjectPageChange(page) {
      this.projectFilters.page = page
      this.loadProjectTransactions()
    },
    getStatusLabel(status) {
      if (typeof status === 'object' && status !== null) {
        return this.$i18n.locale === 'ar' ? status.label_ar : status.label
      }
      const option = this.statusOptions.find(opt => opt.value === status)
      if (!option) return status
      return this.$i18n.locale === 'ar' ? option.label_ar : option.label
    },
    getTransactionTypeLabel(transactionType) {
      if (!transactionType) return '-'
      if (typeof transactionType === 'object') {
        return this.$i18n.locale === 'ar' ? transactionType.label_ar : transactionType.label
      }
      const option = this.transactionTypeOptions.find(opt => opt.value === transactionType)
      return option ? (this.$i18n.locale === 'ar' ? option.label_ar : option.label) : transactionType
    },
    getTransactionReasonLabel(transactionReason) {
      if (!transactionReason) return '-'
      if (typeof transactionReason === 'object') {
        return this.$i18n.locale === 'ar' ? transactionReason.label_ar : transactionReason.label
      }
      return transactionReason
    },
    getSourceLabel(source, paymentSource) {
      if (!source) return '-'

      // Get payment_source value (handle both object and string)
      const paymentSourceValue = (paymentSource && typeof paymentSource === 'object' && paymentSource.value)
        ? paymentSource.value
        : paymentSource

      // When payment_source is 'account', the source is an account object
      if (paymentSourceValue === 'account') {
        // Account has: account_number, code, name
        if (source.account_number) {
          return `${source.account_number} - ${source.name || ''}`
        }
        if (source.code) {
          return `${source.code} - ${source.name || ''}`
        }
        return source.name || '-'
      }

      // When payment_source is 'wallet', the source is a wallet object
      if (paymentSourceValue === 'wallet') {
        // Wallet has: wallet_number, employee (with name/full_name)
        if (source.wallet_number) {
          const employeeName = (source.employee && (source.employee.full_name || source.employee.name)) || ''
          return employeeName ? `${source.wallet_number} - ${employeeName}` : source.wallet_number
        }
        // Fallback if wallet_number is not available
        const employeeName = (source.employee && (source.employee.full_name || source.employee.name)) || ''
        return employeeName || source.name || '-'
      }

      // Fallback: try to detect based on object properties
      if (source.account_number || source.code) {
        // Looks like an account
        return source.account_number
          ? `${source.account_number} - ${source.name || ''}`
          : `${source.code} - ${source.name || ''}`
      }

      if (source.wallet_number) {
        // Looks like a wallet
        const employeeName = (source.employee && (source.employee.full_name || source.employee.name)) || ''
        return employeeName ? `${source.wallet_number} - ${employeeName}` : source.wallet_number
      }

      return source.name || '-'
    },
    getSourceRoute(source, paymentSource) {
      if (!source) return null

      // Get payment_source value (handle both object and string)
      const paymentSourceValue = (paymentSource && typeof paymentSource === 'object' && paymentSource.value)
        ? paymentSource.value
        : paymentSource

      // When payment_source is 'account', navigate to account view
      if (paymentSourceValue === 'account' && source.id) {
        return {
          name: 'accounting-accounts-view',
          params: { id: source.id },
        }
      }

      // When payment_source is 'wallet', navigate to employee details
      if (paymentSourceValue === 'wallet' && source.employee && source.employee.id) {
        return {
          name: 'employeeDetails',
          params: { id: source.employee.id },
        }
      }

      // Fallback: try to detect based on object properties
      if ((source.account_number || source.code) && source.id) {
        // Looks like an account
        return {
          name: 'accounting-accounts-view',
          params: { id: source.id },
        }
      }

      if (source.wallet_number && source.employee && source.employee.id) {
        // Looks like a wallet
        return {
          name: 'employeeDetails',
          params: { id: source.employee.id },
        }
      }

      return null
    },
    hasReceipt(transaction) {
      if (!transaction) return false
      // Check if receipt is an array and has first element with url
      if (Array.isArray(transaction.receipt) && transaction.receipt.length > 0 && transaction.receipt[0].url) {
        return true
      }
      // Check if receipt is an object with url
      if (transaction.receipt && transaction.receipt.url) {
        return true
      }
      // Fall back to receipt_path
      return !!transaction.receipt_path
    },
    getReceiptUrl(receiptPath) {
      if (!receiptPath) return ''
      // If receipt_path is already a full URL, return it as is
      if (receiptPath.startsWith('http://') || receiptPath.startsWith('https://')) {
        return receiptPath
      }
      // If receipt_path starts with /storage, it's a Laravel storage path
      if (receiptPath.startsWith('/storage') || receiptPath.startsWith('storage/')) {
        const cleanPath = receiptPath.startsWith('/') ? receiptPath : `/${receiptPath}`
        return `${process.env.VUE_APP_BASE_URL}${cleanPath}`
      }
      // Otherwise, assume it's a storage path and prepend /storage
      const cleanPath = receiptPath.startsWith('/') ? receiptPath : `/${receiptPath}`
      return `${process.env.VUE_APP_BASE_URL}/storage${cleanPath}`
    },
    showReceiptModal(transaction) {
      let receiptUrl = null

      // Check if receipt is an array and get first element's url
      if (Array.isArray(transaction.receipt) && transaction.receipt.length > 0 && transaction.receipt[0].url) {
        receiptUrl = transaction.receipt[0].url
      }
      // Check if receipt is an object with url
      else if (transaction.receipt && transaction.receipt.url) {
        receiptUrl = transaction.receipt.url
      }
      // Fall back to receipt_path
      else if (transaction.receipt_path) {
        receiptUrl = transaction.receipt_path
      }

      this.currentReceiptUrl = receiptUrl ? this.getReceiptUrl(receiptUrl) : null
      this.$refs.viewReceiptModal.show()
    },
    isImageFile(url) {
      if (!url) return false
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp']
      const lowerUrl = url.toLowerCase()
      return imageExtensions.some(ext => lowerUrl.includes(ext))
        || lowerUrl.includes('image/')
    },
    isPdfFile(url) {
      if (!url) return false
      const lowerUrl = url.toLowerCase()
      return lowerUrl.includes('.pdf') || lowerUrl.includes('application/pdf')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.customer-header {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-right: 4px solid #7367f0;
}

.customer-avatar {
    font-weight: bold;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.info-item {
    display: flex;
    align-items: flex-start;

    div {
        flex: 1;
    }
}

.financial-info {
    .financial-item {
        border: 1px solid #e9ecef;
        transition: all 0.3s ease;

        &:hover {
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
            transform: translateY(-2px);
        }
    }
}

.additional-info {
    .info-row {
        &:last-child {
            border-bottom: none !important;
        }
    }
}

.card {
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    border: 1px solid #e9ecef;

    .card-header {
        background-color: #f8f9fa;
        border-bottom: 1px solid #e9ecef;
        font-weight: 600;
        color: #495057;
        text-align: right;
    }
}

// RTL Support
.text-right {
    text-align: right;
}

.ml-1 {
    margin-right: 0.25rem;
    margin-left: 0 !important;
}

.ml-2 {
    margin-right: 0.5rem;
    margin-left: 0 !important;
}
</style>
